import "./WeeklyTopTen.scss";
import WeeklyTopTenPage from "./WeeklyTopTen";
export default WeeklyTopTenPage;